import { GET_HOLIDAY, GET_HOLIDAY_SUCCESS, GET_HOLIDAY_FAILURE, UPDATE_HOLIDAY_STATUS, UPDATE_HOLIDAY_STATUS_SUCCESS, UPDATE_HOLIDAY_STATUS_FAILURE, DELETE_HOLIDAY, DELETE_HOLIDAY_SUCCESS, DELETE_HOLIDAY_FAILURE, EDIT_HOLIDAY, EDIT_HOLIDAY_SUCCESS, EDIT_HOLIDAY_FAILURE, ADD_HOLIDAY, ADD_HOLIDAY_SUCCESS, ADD_HOLIDAY_FAILURE } from "../Constants";

const init = {
  data: {},
  delete_data: {},
  edit_data: {},
  add_data: {},
  copy_data: {},
  update_data: {},
};

const HolidayReducer = (state = init, action) => {
  switch (action.type) {
    case GET_HOLIDAY:
      return { ...state, loading: true };
    case GET_HOLIDAY_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case GET_HOLIDAY_FAILURE:
      return { ...state, loading: false, data: action.payload };
    case UPDATE_HOLIDAY_STATUS:
      return { ...state, loading: true };
    case UPDATE_HOLIDAY_STATUS_SUCCESS:
      return { ...state, loading: false, update_data: action.payload };
    case UPDATE_HOLIDAY_STATUS_FAILURE:
      return { ...state, loading: false, update_data: action.payload };
    case DELETE_HOLIDAY:
      return { ...state, loading: true };
    case DELETE_HOLIDAY_SUCCESS:
      return { ...state, loading: false, delete_data: action.payload };
    case DELETE_HOLIDAY_FAILURE:
      return { ...state, loading: false, delete_data: action.payload };
    case EDIT_HOLIDAY:
      return { ...state, loading: true };
    case EDIT_HOLIDAY_SUCCESS:
      return { ...state, loading: false, edit_data: action.payload };
    case EDIT_HOLIDAY_FAILURE:
      return { ...state, loading: false, edit_data: action.payload };
    case ADD_HOLIDAY:
      return { ...state, loading: true };
    case ADD_HOLIDAY_SUCCESS:
      return { ...state, loading: false, add_data: action.payload };
    case ADD_HOLIDAY_FAILURE:
      return { ...state, loading: false, add_data: action.payload };
    default:
      return state;
  }
};

export default HolidayReducer;
